import React from 'react';
import config from '../config';
import SectionReveal from '../components/SectionReveal';
import './Contact.css';

function Contact() {
  return (
    <main className="contact-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content">
            <span className="section-badge">Get in Touch</span>
            <h1>Contact Us</h1>
            <p>We'd love to hear from you. Reach out for orders, partnerships, or feedback.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <SectionReveal animation="slideInLeft">
              <div className="contact-info">
                <h2>Let's Connect</h2>
                <p className="contact-info__desc">
                  Whether you want to place an order, discuss bulk deals, or explore corporate partnerships — we're just a message away.
                </p>

                <div className="contact-info__items">
                  <div className="contact-info__item">
                    <span className="contact-info__icon">📍</span>
                    <div>
                      <h4>Address</h4>
                      <p>{config.contact.address}</p>
                    </div>
                  </div>
                  <div className="contact-info__item">
                    <span className="contact-info__icon">📞</span>
                    <div>
                      <h4>Phone</h4>
                      <a href={`tel:${config.contact.phoneRaw}`}>{config.contact.phone}</a>
                    </div>
                  </div>
                  <div className="contact-info__item">
                    <span className="contact-info__icon">💬</span>
                    <div>
                      <h4>WhatsApp</h4>
                      <a href={`https://wa.me/${config.contact.whatsapp}`} target="_blank" rel="noopener noreferrer">
                        Chat with us
                      </a>
                    </div>
                  </div>
                  <div className="contact-info__item">
                    <span className="contact-info__icon">📸</span>
                    <div>
                      <h4>Instagram</h4>
                      <a href={config.contact.instagramUrl} target="_blank" rel="noopener noreferrer">
                        @{config.contact.instagram}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="contact-info__actions">
                  <a
                    href={config.getWhatsAppUrl('Hi! I have a query about FAL SUTRA.')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-whatsapp"
                  >
                    💬 WhatsApp Us
                  </a>
                  <a href={`tel:${config.contact.phoneRaw}`} className="btn btn-secondary">
                    📞 Call Now
                  </a>
                </div>
              </div>
            </SectionReveal>

            <SectionReveal animation="slideInRight" delay={0.2}>
              <div className="contact-map-wrap">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.5!2d72.49!3d23.05!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDAzJzAwLjAiTiA3MsKwMjknMjQuMCJF!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{border: 0, borderRadius: 'var(--radius-lg)', minHeight: '450px'}}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="FAL SUTRA Location"
                />
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>

      {/* Delivery Area Info */}
      <section className="section contact-delivery-section">
        <div className="container">
          <SectionReveal>
            <div className="contact-delivery-card">
              <h2>🚀 Delivery Area</h2>
              <p>
                We currently deliver within a <strong>{config.delivery.radiusKm} KM radius</strong> of {config.delivery.baseArea}.
                Estimated delivery time: <strong>{config.delivery.estimatedTime}</strong>.
              </p>
              <p className="contact-delivery-card__note">
                Free delivery on orders above ₹{config.delivery.freeDeliveryAbove}!
              </p>
            </div>
          </SectionReveal>
        </div>
      </section>
    </main>
  );
}

export default Contact;
